import React from "react";
import { FaInfo } from "react-icons/fa";

const Info = () => {
    return (
        <div className="info">
            <div className="heading">
                <FaInfo className="info-icon" />
                <span>Info</span>
            </div>
            <div className="description">
                The responsiveness of this site is under 
                development, please switch to desktop
                mode and landscape mode if you are viewing on Mobile.
            </div>
        </div>
    )
}

export default Info;